export enum ACCESS_TYPE {
  VIEW = 'View',
  VIEW_AND_COMMENT = 'View & Comment',
  EDIT_AND_RE_SHARE = 'Edit & Re-Share',
  SUBGROUP_SPECIFIC_ACCESS = 'Subgroup Specific Access',
  NO_ACCESS = 'No Access',
  WITHOUT_ACCESS = 'No Access',
  COMMENT_AND_CREATE = 'Comment & Create',
  COMMENT_CREATE_AND_RESHARE = 'Comment, Create & Reshare',
  ALL = 'All',
}

export const ACCESS_TYPE_KEYS = {
  [ACCESS_TYPE.VIEW]: 'VIEW',
  [ACCESS_TYPE.VIEW_AND_COMMENT]: 'VIEW_AND_COMMENT',
  [ACCESS_TYPE.EDIT_AND_RE_SHARE]: 'EDIT_AND_RE_SHARE',
  [ACCESS_TYPE.SUBGROUP_SPECIFIC_ACCESS]: 'SUBGROUP_SPECIFIC_ACCESS',
  [ACCESS_TYPE.COMMENT_AND_CREATE]: 'COMMENT_AND_CREATE',
  [ACCESS_TYPE.COMMENT_CREATE_AND_RESHARE]: 'COMMENT_CREATE_AND_RESHARE',
  [ACCESS_TYPE.NO_ACCESS]: 'NO_ACCESS',
};

export enum ACCESS_TYPE_ENUM {
  VIEW = 'VIEW',
  VIEW_AND_COMMENT = 'VIEW_AND_COMMENT',
  COMMENT_AND_CREATE = 'COMMENT_AND_CREATE',
  COMMENT_CREATE_AND_RESHARE = 'COMMENT_CREATE_AND_RESHARE',
  EDIT_AND_RE_SHARE = 'EDIT_AND_RE_SHARE',
  SUBGROUP_SPECIFIC_ACCESS = 'SUBGROUP_SPECIFIC_ACCESS',
  NO_ACCESS = 'NO_ACCESS',
  WITHOUT_ACCESS = 'WITHOUT_ACCESS',
  ALL = 'ALL',
}
